import React, { useState, useRef } from 'react'
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, linkWithCredential, PhoneAuthProvider } from "firebase/auth";
import useMainContext from '../hooks/useMainContext'
import PhoneValidation from '../components/phoneValidation'
import { useEffect } from 'react'
import Notification from '../components/notification';
import { Button, Link } from '@material-ui/core';
import { getClientData, updateClient } from '../firebase/obj/client';


export default function PhoneValidationwithData() {
    const { isAdmin, user, config, setUser, isChef, isDelivery } = useMainContext()
    const [open, setOpen] = useState(false)
    const [phone, setPhone] = useState(false)
    const [code, setCode] = useState()
    const [codeSent, setCodeSent] = useState(false)
    const [error, setError] = useState('')
    const [verificationId, setVerificationId] = useState("")
    const [showNotification, setShowNotification] = useState(false)
    const [showNotificationSuccess, setShowNotificationSuccess] = useState(false)

    // Ref para rastrear si el componente está montado
    const isMounted = useRef(true);

    // Se ejecuta cuando el componente se desmonta
    useEffect(() => {
        return () => {
            isMounted.current = false;
            // Limpiar el recaptcha si existe
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!isMounted.current) return;

        setShowNotification(false)
        if (config?.requirePhoneValidation && !open && user && !user?.phoneNumber && !isAdmin) {
            // espero 5 segundos para mostrar la notificación de que se requiere validar el teléfono
            setTimeout(() => {
                !isAdmin && setShowNotification(true)
            }, 5000)
        } else {
            setShowNotification(false)
        }
    }, [open, user, config])

    useEffect(() => {
        if (!isMounted.current) return;

        // console.log('user', user, 'config', config)
        if (config?.requirePhoneValidation && user && !user?.phoneNumber && !isAdmin) {
            // console.log('user', user)
            setTimeout(() => {
                !isAdmin && setOpen(true)
            }, 2000)
        } else if (user?.phoneNumber) {
            setOpen(false)
        }
    }, [isAdmin, user, config])

    const handleSendOTP = async () => {
        try {
            if (!isMounted.current) return;

            // getAuth().settings.appVerificationDisabledForTesting = true;
            let _phone = phone
            setError('')
            const auth = getAuth()

            if (!_phone?.includes("+")) {
                _phone = `+${_phone}`
                setPhone(_phone)
            }

            // const recaptchaVerifier = new RecaptchaVerifier('recaptcha-phone', {}, auth)
            if (!window.recaptchaVerifier) {
                window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-phone', {
                    'size': 'invisible'
                }, auth);

                // window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-phone', {
                //     'size': 'normal',
                //     'callback': () => console.log('Captcha resuelto')
                // }, auth);
            }


            const provider = new PhoneAuthProvider(auth)
            // console.log('PhoneAuthProvider', provider)

            const verificationId = await provider.verifyPhoneNumber(_phone, window.recaptchaVerifier)

            // console.log('verificationId', verificationId)
            setVerificationId(verificationId);
            setCodeSent(true)
        } catch (error) {
            console.error('Error al enviar código', error)
            setError('Error al enviar código')
        }
    }

    const handleValidateOTP = async () => {
        try {
            const auth = getAuth()
            const authCredential = PhoneAuthProvider.credential(verificationId, code)
            if (authCredential) {
                // console.log('vinculo cuentas', user, authCredential)
                await linkWithCredential(auth.currentUser, authCredential)
                // console.log('linkedResult', linkedResult)
                const refreshedUser = auth.currentUser;
                await refreshedUser.reload();

                console.log('refreshedUser', refreshedUser)

                const u = {
                    ...user,
                    phoneNumber: refreshedUser.phoneNumber,
                    phone: refreshedUser.phoneNumber
                }

                setUser(u)
                setShowNotification(false)
                setOpen(false)
                await handleUpdateClient(refreshedUser)
            }

        } catch (error) {
            console.error('Error al validar código', error)
            setError('Error al validar código')
        }
    }

    const handleUpdateClient = async (user) => {
        try {
            console.log(`actualizo phoneNumber ${user?.phoneNumber}, phone ${user?.phone} para usuario ${user?.uid}`)
            const client = await getClientData(user.uid)
            if (!client)
                return
            client.phone = user.phoneNumber
            await updateClient(client)
            setShowNotificationSuccess(true)
        } catch (error) {
            console.error('Error al actualizar informacion del cliente', error)
        }

    }

    if (isAdmin || isChef || isDelivery || !config?.requirePhoneValidation)
        return null

    return (
        <>
            <Notification
                autoHideDuration={2000}
                notificationOpen={showNotificationSuccess}
                severity={'success'}
                notificationMessage={'¡Se ha validado su teléfono exitosamente!'}
                closeButton={true}
                handleNotificationClose={() => setShowNotificationSuccess(false)}
            />
            <Notification
                autoHideDuration={null}
                notificationOpen={showNotification}
                severity={'warning'}
                notificationMessage={'Valide su número de teléfono'}
                closeButton={false}
            >
                <Link
                    component="button"
                    variant="body2"
                    onClick={() => setOpen(true)}
                    style={{ textDecoration: 'none', color: '#ffffff' }}
                >
                    Validar número de teléfono
                </Link>
            </Notification>
            <PhoneValidation
                open={open}
                codeSent={codeSent}
                setOpen={setOpen}
                phone={phone}
                setPhone={setPhone}
                sendOTP={handleSendOTP}
                code={code}
                setCode={setCode}
                validateOTP={handleValidateOTP}
                error={error}
            />
        </>

    )
}
